/**
 * AbsenceSummaryCards — Kennzahlen-Karten für das Jahr.
 */
import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { TrendingUp } from 'lucide-react';
import { ABSENCE_TYPES } from './constants';

export const AbsenceSummaryCards = ({ summary, year }) => {
  if (!summary) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="border-border/60">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
              <TrendingUp className="h-5 w-5 text-gray-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Gesamt {year}</p>
              <p className="text-2xl font-bold">{summary.total_days} Tage</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {ABSENCE_TYPES.map((type) => {
        const typeData = summary.by_type?.[type.value] || { count: 0, days: 0 };
        return (
          <Card key={type.value} className="border-border/60">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${type.color}`}>
                  <type.icon className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">{type.label}</p>
                  <p className="text-2xl font-bold">{typeData.days} Tage</p>
                  <p className="text-xs text-muted-foreground">{typeData.count} Einträge</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
